export function cardGrid (state = {}, action) {
    switch (action.type) {
        case 'OWNED_CARDS_RESPONSE':  
          return {
              ...state,
             cardGridData: action.payload,
             selectedCard: 0,
             sets: action.payload.sets,
             isUserLoggedIn: action.userActive.login,
             userName: action.userActive.userName,
             gridLoading: false
          }
          case 'ADD_CARD_RESPONSE':
            //Add the new item to the grid list
            let newGridData = state.cardGridData
            newGridData.push(action.payload.data.createOwnedCard)
            //console.log('Setting sel ind to ' + newGridData.length - 1)
          return {
            ...state,
             cardGridData: newGridData,
             selectedCard: newGridData.length - 1,
             lastAdded: action.payload.data.createOwnedCard.id
          };
          case 'SEL_CARD_CHANGE':
            return {
              ...state,
               selectedCard: action.payload,
               priceLoading: action.userActive.login,
               isUserLoggedIn: action.userActive.login,
               userName: action.userActive.userName
            };
          case 'UPDATE_CARD_RESPONSE':
            //console.log('UCR1 ' + JSON.stringify(action.payload.data.updateOwnedCard))
          var newGrid = state.cardGridData.map(function(a) {
              return a.id === action.payload.data.updateOwnedCard.id ?  action.payload.data.updateOwnedCard : a;
          });
            return {
              ...state,
               cardGridData: newGrid
            };
          case 'GET_CARD_DETAILS_RESPONSE':
            return {
              ...state,
               selectedCardDetails: action.payload,
               priceLoading: false
            };
          case 'GET_PRICE_DETAILS_RESPONSE':
            let fullDetails = state.selectedCardDetails
            fullDetails.queryData = action.payload
            return {
              ...state,
              priceData: fullDetails
              
            }
          case 'GET_PLAYER_RESPONSE':
            return {
              ...state,
              currPlayerName: action.payload
            }
          case 'GET_IMG_RESPONSE':
            return {
              ...state,
              currAddVals: action.payload
            }
          case 'SORT_GRID_RESPONSE':
            return {
              ...state,
              cardGridData: action.payload.cardGridData,
              selectedCard: action.payload.selectedCard, 
              sortDir: action.payload.sortDirection 
            }
          case 'USER_LOGOUT':
            return {
              ...state,
               isUserLoggedIn: false,
               userName: undefined
            };
          case 'GRID_DATA_INIT':
            return {
              ...state,
              gridLoading: true
            };
          case 'CHECKLIST_INIT':
            return {
              ...state,
              checklistLoading: true
            };
          case 'INIT_VALS_RESPONSE':
            return {
              ...state,
              setList: action.payload
            };
          case 'CHECKLIST_RESPONSE':
            return {
              ...state,
              currChecklist: action.payload,
              checklistLoading: false
            };
          case 'APPLY_FILTERS' :
            return {
              ...state,
              additionalFilters: action.payload
            };
            case 'FETCH_STATE' :
              return {
                state
              }
        default:
          return state
      }
}